import { isEqual } from "lodash-es";

/**
 * Check if the users data has been changed.
 *
 * @param state
 * @returns {boolean}
 */
export const userChanged = (state) => {
    const item = state.editModal.user;
    const original = state.editModal.originalUser;
    return !isEqual(item, original);
};



// WEBPACK FOOTER //
// ./src/store/modules/admin/getters.js